export default __webpack_public_path__ + "files/aa266af534854336c216e7d744efcbb9.mp3";